import { validatePasswordRules } from "./User";

export const PASSWORD_RULE_LIST = [
  "min8",
  "lowercase",
  "uppercase",
  "digits",
  "noSpaces",
] as const;

export type PasswordRule = (typeof PASSWORD_RULE_LIST)[number];

export function isPasswordRuleValid(
  password: string,
  rule: PasswordRule,
): boolean {
  return Boolean(validatePasswordRules(password, [rule]));
}
